module.exports = __webpack_public_path__ + "static/media/23.8c731626.wav";